// extracted by mini-css-extract-plugin
module.exports = {"select":"SelectShare_select__10N1F","group":"SelectShare_group__2lBiJ"};